
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AddPartnerToGroupResponse": [
      "ClientError",
      "PartnerGroup"
    ],
    "BulkAccountCreationReportDownloadURLResponse": [
      "ClientError",
      "ReportFileLocation"
    ],
    "BulkAccountCreationRequestUploadURLResponse": [
      "ClientError",
      "RequestFileLocation"
    ],
    "BulkAccountCreationTemplateDownloadURLResponse": [
      "ClientError",
      "TemplateFileLocation"
    ],
    "BulkAccountCreationUploadHistoryResponse": [
      "BulkAccountCreationUploadHistoryOutput",
      "ClientError"
    ],
    "CMSEntry": [
      "CMSEventEntry",
      "CMSResourceEntry"
    ],
    "CertifiedUsersResult": [
      "CertificationEntryConnection",
      "ClientError"
    ],
    "Connection": [
      "CMSEntryConnection",
      "CertificationEntryConnection",
      "NotificationConnection",
      "PartnerAdvertiserConnection",
      "PartnerAdvertiserInviteConnection",
      "PartnerConnection"
    ],
    "DeleteListingSubmissionResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "DeletePartnerAdvertiserInviteResult": [
      "ClientError",
      "NotFound",
      "PartnerAdvertiserInvite"
    ],
    "DeletePartnerRegistrationResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "DeletePartnerUserInviteResult": [
      "ClientError",
      "NotFound",
      "PartnerUserInvite"
    ],
    "DeleteSocialDataResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "Edge": [
      "CMSEntryEdge",
      "CertificationEntryEdge",
      "NotificationEdge",
      "PartnerAdvertiserEdge",
      "PartnerAdvertiserInviteEdge",
      "PartnerEdge"
    ],
    "Error": [
      "ClientError",
      "ConcurrentlyModified",
      "InvalidCursor",
      "InvalidInput",
      "InvalidRequestStructure",
      "InvalidState",
      "NonRetryableDependency",
      "NotFound",
      "Retryable",
      "RetryableDependency"
    ],
    "FeaturedContent": [
      "CaseStudy"
    ],
    "GenerateReportReponse": [
      "ClientError",
      "PendingReport"
    ],
    "GetReportResponse": [
      "CompletedReport",
      "InvalidState",
      "NoReport",
      "PendingReport"
    ],
    "LinkOrUnlinkApplicationResponse": [
      "ApplicationDetails",
      "ClientError",
      "InvalidState"
    ],
    "NotificationConnectionResult": [
      "ClientError",
      "InvalidCursor",
      "InvalidRequestStructure",
      "NotificationConnection"
    ],
    "OnlineAgreementOrMutationErrors": [
      "MutationError",
      "OnlineAgreement"
    ],
    "PartnerAdvertiserInviteResult": [
      "ClientError",
      "NotFound",
      "PartnerAdvertiserInvite"
    ],
    "PartnerCertificationsResult": [
      "ClientError",
      "PartnerCertificationEntries"
    ],
    "PartnerFeaturedContentRequestsResult": [
      "ClientError",
      "FeaturedContentRequestEntries"
    ],
    "PartnerRegistrationEligibilityResult": [
      "ClientError",
      "PartnerRegistrationEligibility"
    ],
    "PartnerUserInviteResult": [
      "ClientError",
      "NotFound",
      "PartnerUserInvite"
    ],
    "PartnerUserMutationResult": [
      "ClientError",
      "InvalidState",
      "NotFound",
      "PartnerUser"
    ],
    "PitchDeckDownloadUrlResult": [
      "ClientError",
      "PitchDeckDownloadUrl"
    ],
    "Placeholder": [
      "PlaceholderList",
      "PlaceholderSingle"
    ],
    "Principal": [
      "AuthPortalPrincipal"
    ],
    "RedeemPartnerAdvertiserInviteResult": [
      "ClientError",
      "InvalidState",
      "NotFound",
      "PartnerAdvertiserInvite"
    ],
    "RedeemPartnerUserInviteResult": [
      "ClientError",
      "InvalidState",
      "NotFound",
      "PartnerUserInvite"
    ],
    "RemovePartnerFromGroupResponse": [
      "ClientError",
      "PartnerGroup"
    ],
    "ResendPartnerAdvertiserInviteResult": [
      "ClientError",
      "NotFound",
      "PartnerAdvertiserInvite"
    ],
    "ResendPartnerUserInviteResult": [
      "ClientError",
      "NotFound",
      "PartnerUserInvite"
    ],
    "SendPartnerAdvertiserInviteResult": [
      "ClientError",
      "PartnerAdvertiserInvite"
    ],
    "SubmitBulkAccountCreationResponse": [
      "ClientError",
      "SubmitBulkAccountCreationOutput"
    ],
    "SubmitPartnerLogoResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "SubmitPartnerRegistrationResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "UnpublishListingResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "UnsubmitPartnerLogoResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "UpdateApplicationResponse": [
      "ApplicationDetails",
      "ClientError"
    ],
    "UpdateFeaturedContentRequestResult": [
      "ClientError",
      "FeaturedContentRequest",
      "MutationError"
    ],
    "UpdateLocalizedListingResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "UpdatePartnerRegistrationResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "UpdateSocialDataResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "UpdateUniversalListingResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "UpdateUnmoderatedPartnerRegResult": [
      "ClientError",
      "MutationError",
      "Partner"
    ],
    "UserInviteAdvertisersResult": [
      "ClientError",
      "InvalidState",
      "NotFound",
      "UserInviteAdvertisers"
    ],
    "UserPreferencesResult": [
      "ClientError",
      "NonRetryableDependency",
      "RetryableDependency",
      "UserPreferences"
    ],
    "Verifiable": [
      "VerifiableLogoAsset",
      "VerifiablePartnerRegistration"
    ],
    "VerifiableWithInitialApproval": [
      "VerifiableLocalizedDirectoryListingData"
    ]
  }
};
      export default result;
    